/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#stories-container .story.template-cross-promo .story-block-group .story-block.story-block-banner.disney-plus .background-wrapper .fade-in-on-hover{position:relative;max-height:none}#stories-container .story.template-cross-promo .story-block-group .story-block.story-block-banner.disney-plus .background-wrapper img{height:auto}"];
export { styles as styles };
